export default __webpack_public_path__ + "static/media/orkan-fantom-logo.74e6088c.svg";